import type { TemplateName } from "../types/route-context";

type ThemeEventMap = {
  "app:booted": { template: TemplateName };
  "route:initialized": { template: TemplateName };
};

class ThemeEventBus {
  private target = new EventTarget();

  on<T extends keyof ThemeEventMap>(
    eventName: T,
    handler: (payload: ThemeEventMap[T]) => void
  ): () => void {
    const listener = ((event: Event) => {
      const customEvent = event as CustomEvent<ThemeEventMap[T]>;
      handler(customEvent.detail);
    }) as EventListener;

    this.target.addEventListener(eventName, listener);

    return () => {
      this.target.removeEventListener(eventName, listener);
    };
  }

  emit<T extends keyof ThemeEventMap>(eventName: T, payload: ThemeEventMap[T]): void {
    this.target.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
  }
}

export const themeEvents = new ThemeEventBus();
